'use strict';

app.factory('S3', ['$http', 'localStorageService', '$rootScope', '$location', 'Popup', '$pusher', 'env_config', 'Auth', '$timeout',
    function ($http, localStorageService, $rootScope, $location, Popup, $pusher, env_config, Auth, $timeout) {
        var service = {};

        /**
         * get S3 images
         *
         * @param  string   username
         * @param  string   password
         * @param  Function callback
         */
        service.getObject = function(filename, callback) { 
            AWS.config.update({
              region: env_config.aws.s3.region,
              credentials: AWS.config.credentials
            });

            var bucket = new AWS.S3({
                    //endpoint: 's3-ap-southeast-1.amazonaws.com',
                    params: {Bucket: env_config.aws.s3.bucket}, 
                    //region: env_config.aws.s3.region,
                    //accessKeyId: $rootScope.globals.awsAccessKeyId,
                    //secretAccessKey: $rootScope.globals.awsSecretAccessKey
            }); 
            var self = this;
            var resp = {status:400};
            bucket.getObject({Key: filename}, function(err, file){
                //setTimeout(function(){
                    if (file !== null){
                        resp = {data: "data:image/jpeg;base64," + self.encode(file.Body), status:200};
                        callback(resp);
                    }   
                //}, 6000);
            });
        };

        service.encode = function(data) {
            var str = data.reduce(function(a,b){ return a+String.fromCharCode(b) },'');
            return btoa(str).replace(/.{76}(?=.)/g,'$&\n');
        }

        return service;
    }]);